exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".round-box[data-v-1d816530]{width:8px;height:8px;border-radius:50%;margin-right:8px}.long-text[data-v-1d816530]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.startTime[data-v-1d816530]{font-weight:400;font-size:13px;color:#969696;margin-top:4px}.box-card[data-v-1d816530]{border-radius:8px}", ""]);

// exports
